import { object, string } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  prescriptionId: string().required(),
})

export const url = ({ prescriptionId }) => `/v1/prescriptions/${prescriptionId}`
